const RedundantRouteMixin = {
  methods: {
    rerouteIfRouteChanged(currentRoute, newRoute) {
      const from = currentRoute.fullPath
      const to = this.$router.resolve(newRoute).route.fullPath
      if (from !== to) {
        // only route replace if the route changed
        this.$router.replace(newRoute)
      }
    }
  }
}
export default RedundantRouteMixin;